(function(){
    'use strict';

    const tooltipButtons = document.getElementsByClassName('js-tooltip-button');

    // Prevent any button actions on the tooltips
    for (let i = 0, j = tooltipButtons.length; i < j; ++i) {
        tooltipButtons[i].addEventListener('click', (evt) => { evt.preventDefault(); });
    }
}());